import { PresetMedia } from '@nucleus/types/web';

export const cardMediaFull: PresetMedia = {
  mediaOptions: {
    blending: {
      fade: 'top',
      opacity: 0.85,
      blendMode: 'none',
      fadeIntensity: 0.5,
    },
    image: {
      tile: 'none',
      scale: 'cover',
    },
    video: {
      image: {
        tile: 'none',
        scale: 'cover',
      },
    },
    useColor: false,
  },
};
